<div class="content" [class.has-icon]="icon">
  @if (icon) {
  <mat-icon class="content__icon">{{ icon }}</mat-icon>
  }
  <span class="content__text" [style.-webkit-line-clamp]="displayLines"><ng-content></ng-content></span>
</div>
